import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";


interface propPopUpCustom {
    IsOpen?: boolean;
    setIsOpen?: any;
    onClose?: ()=>void;
    sMaxWidth? : 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    JsxDialogHeader?: any;
    JsxDialogContent?: any;
    JsxDialogAction?: any;
}

const PopUpCustom = (props : propPopUpCustom) => {

    const {
        IsOpen,
        setIsOpen,
        onClose,
        sMaxWidth = "md",
        JsxDialogHeader,
        JsxDialogContent,
        JsxDialogAction,
    } = props;

    return (
        <Dialog
            open={IsOpen}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={sMaxWidth}
            style={{
                top:'5%'
            }}
        >
            <DialogTitle>
                {JsxDialogHeader}
            </DialogTitle>
            <hr style={{width:'100%',margin:'0'}}/>
            <DialogContent>
                {JsxDialogContent}
            </DialogContent>
            <DialogActions>
               {JsxDialogAction}
            </DialogActions>
        </Dialog>
    )
}

export default PopUpCustom